import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function NewInvoiceModal({ isOpen, onClose, onSave }) {
  const [formData, setFormData] = useState({
    client: '',
    project: '',
    amount: '',
    date: new Date().toISOString().split('T')[0]
  });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      id: `INV-${Math.floor(Math.random() * 1000) + 2000}`,
      ...formData,
      amount: parseFloat(formData.amount),
      status: 'Draft'
    });
    setFormData({ client: '', project: '', amount: '', date: new Date().toISOString().split('T')[0] });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      
      <div className="relative bg-charcoal-panel border border-[#333] rounded-2xl w-full max-w-md shadow-2xl animate-in zoom-in-95 duration-200">
        <div className="flex justify-between items-center p-6 border-b border-[#333]">
          <h2 className="text-xl font-medium text-cream">Create New Invoice</h2>
          <button onClick={onClose} className="text-cream-muted hover:text-cream transition-colors">
            <SafeIcon name="X" className="w-5 h-5" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-cream-muted mb-1.5">Client Name</label>
            <input 
              required
              type="text" 
              value={formData.client}
              onChange={e => setFormData({...formData, client: e.target.value})}
              className="w-full bg-charcoal-base border border-[#333] rounded-lg px-4 py-2.5 text-cream focus:outline-none focus:border-invoice-green transition-colors"
              placeholder="e.g. Acme Corp"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-cream-muted mb-1.5">Project / Description</label>
            <input 
              required
              type="text" 
              value={formData.project}
              onChange={e => setFormData({...formData, project: e.target.value})}
              className="w-full bg-charcoal-base border border-[#333] rounded-lg px-4 py-2.5 text-cream focus:outline-none focus:border-invoice-green transition-colors"
              placeholder="e.g. Q4 Retainer"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-cream-muted mb-1.5">Amount ($)</label>
              <input 
                required
                type="number" 
                min="0"
                step="0.01"
                value={formData.amount}
                onChange={e => setFormData({...formData, amount: e.target.value})}
                className="w-full bg-charcoal-base border border-[#333] rounded-lg px-4 py-2.5 text-cream focus:outline-none focus:border-invoice-green transition-colors"
                placeholder="0.00"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-cream-muted mb-1.5">Issue Date</label>
              <input 
                required
                type="date" 
                value={formData.date}
                onChange={e => setFormData({...formData, date: e.target.value})}
                className="w-full bg-charcoal-base border border-[#333] rounded-lg px-4 py-2.5 text-cream focus:outline-none focus:border-invoice-green transition-colors"
              />
            </div>
          </div>
          
          <div className="pt-4 flex justify-end gap-3">
            <button 
              type="button" 
              onClick={onClose}
              className="px-4 py-2.5 text-sm font-medium text-cream-muted hover:text-cream transition-colors"
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="px-6 py-2.5 bg-invoice-green hover:bg-emerald-400 text-[#111] rounded-lg text-sm font-medium transition-colors"
            >
              Generate Invoice
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}